import { render, staticRenderFns } from "./qualityTestDetail.vue?vue&type=template&id=20f7b913&scoped=true"
import script from "./qualityTestDetail.vue?vue&type=script&lang=ts"
export * from "./qualityTestDetail.vue?vue&type=script&lang=ts"
import style0 from "./qualityTestDetail.vue?vue&type=style&index=0&id=20f7b913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f7b913",
  null
  
)

export default component.exports